module.exports = __webpack_public_path__ + "static/media/Caliburn_Sub_By-Laws.ca268a49.pdf";